/* eslint-disable */
import React, { useState } from "react"
import { IconButton, Box, Collapse } from "@mui/material"
import VolumeMuteIcon from "@mui/icons-material/VolumeMute"
import VolumeDownIcon from "@mui/icons-material/VolumeDown"
import VolumeOffIcon from "@mui/icons-material/VolumeOff"
import VolumeUpIcon from "@mui/icons-material/VolumeUp"

const VolumeBar = ({ audioRef }) => {
	const [bar, setBar] = useState(false)
	const [volume, setVolume] = useState(1)

	const changeVolumeRef = (event) => {
		const value = event.target.value
		setVolume(value)
		audioRef.current.volume = value
	}

	const showVolumeBar = () => setBar(true)
	const hideVolumeBar = () => setBar(false)

	const muteVolume = () => {
		setVolume(0)
		audioRef.current.volume = 0
	}

	return (
		<Box
			onMouseEnter={showVolumeBar}
			onMouseLeave={hideVolumeBar}
			sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}
		>
			<Collapse in={bar} collapsedSize={0} orientation="vertical">
				<input
					type="range"
					value={volume}
					min={0}
					max={1}
					step={0.01}
					onChange={changeVolumeRef}
					orient="vertical"
				/>
			</Collapse>
			<IconButton onClick={muteVolume}>
				{volume > 0.75 ? (
					<VolumeUpIcon />
				) : volume > 0.5 ? (
					<VolumeDownIcon />
				) : volume > 0.25 ? (
					<VolumeMuteIcon />
				) : (
					<VolumeOffIcon />
				)}
			</IconButton>
		</Box>
	)
}

export default VolumeBar

